import { getEnabledItem as v, silentlyFocused as Z, isItem as K, findFirstEnabledItem as $, groupItemsByRows as ee } from "./5VQZOHHZ.js";
import { useCompositeProviderContext as te, CompositeContextProvider as re } from "./APTFW6PT.js";
import { useFocusable as oe } from "./OE2EFRVA.js";
import { createHook as ne, forwardRef as ie, createElement as se } from "./VOQWLFSQ.js";
import { useTransactionState as ue, useSafeLayoutEffect as R, useEvent as F, useBooleanEvent as ae, useWrapElement as ce, useMergeRefs as le } from "./5GGHRIN3.js";
import { __objRest as O, __spreadProps as fe, __spreadValues as B } from "./3YLGPPWQ.js";
import { flatten2DArray as de, reverseArray as me } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/7PRQYBBV.js";
import { getActiveElement as pe, isTextField as z } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
import { fireBlurEvent as E, isSelfTarget as I, fireKeyboardEvent as ve } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/events.js";
import { focusIntoView as ge, hasFocus as ye } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/utils/focus.js";
import { invariant as Ee } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/PBFD2E7P.js";
import { useRef as M, useEffect as L, useState as Ie, useCallback as Pe } from "react";
import { jsx as Fe } from "react/jsx-runtime";
var Se = "div";
function Ce(r) {
  return r.some((s) => !!s.rowId);
}
function we(r) {
  const s = r.target;
  return s && !z(s) ? !1 : r.key.length === 1 && !r.ctrlKey && !r.metaKey;
}
function Ke(r) {
  return r.key === "Shift" || r.key === "Control" || r.key === "Alt" || r.key === "Meta";
}
function H(r, s, l) {
  return F((e) => {
    var n;
    if (s == null || s(e), e.defaultPrevented || e.isPropagationStopped() || !I(e) || Ke(e) || we(e)) return;
    const f = r.getState(), m = (n = v(r, f.activeId)) == null ? void 0 : n.element;
    if (!m) return;
    const i = e, { view: A } = i, w = O(i, ["view"]), c = l == null ? void 0 : l.current;
    m !== c && m.focus(), ve(m, e.type, w) || e.preventDefault(), e.currentTarget.contains(m) && e.stopPropagation();
  });
}
function Ae(r) {
  return $(
    de(me(ee(r)))
  );
}
function ke(r) {
  const [s, l] = Ie(!1), e = Pe(() => l(!0), []), n = r.useState(
    (f) => v(r, f.activeId)
  );
  return L(() => {
    const f = n == null ? void 0 : n.element;
    s && f && (l(!1), f.focus({ preventScroll: !0 }));
  }, [n, s]), e;
}
var _e = ne(
  function(s) {
    var l = s, {
      store: e,
      composite: n = !0,
      focusOnMove: f = n,
      moveOnKeyPress: m = !0
    } = l, i = O(l, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const A = te();
    e = e || A, Ee(
      e,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const w = M(null), c = M(null), U = ke(e), S = e.useState("moves"), [, V] = ue(
      n ? e.setBaseElement : null
    );
    L(() => {
      var t;
      if (!e || !S || !n || !f) return;
      const { activeId: o } = e.getState(), u = (t = v(e, o)) == null ? void 0 : t.element;
      u && ge(u);
    }, [e, S, n, f]), R(() => {
      if (!e || !S || !n) return;
      const { baseElement: t, activeId: o } = e.getState();
      if (!(o === null) || !t) return;
      const a = c.current;
      c.current = null, a && E(a, { relatedTarget: t }), ye(t) || t.focus();
    }, [e, S, n]);
    const k = e.useState("activeId"), _ = e.useState("virtualFocus");
    R(() => {
      var t;
      if (!e || !n || !_) return;
      const o = c.current;
      if (c.current = null, !o) return;
      const a = ((t = v(e, k)) == null ? void 0 : t.element) || pe(o);
      a !== o && E(o, { relatedTarget: a });
    }, [e, k, _, n]);
    const N = H(
      e,
      i.onKeyDownCapture,
      c
    ), j = H(
      e,
      i.onKeyUpCapture,
      c
    ), h = i.onFocusCapture, q = F((t) => {
      if (h == null || h(t), t.defaultPrevented || !e) return;
      const { virtualFocus: o } = e.getState();
      if (!o) return;
      const u = t.relatedTarget, a = Z(t.currentTarget);
      I(t) && a && (t.stopPropagation(), c.current = u);
    }), b = i.onFocus, G = F((t) => {
      if (b == null || b(t), t.defaultPrevented || !n || !e) return;
      const { relatedTarget: o } = t, { virtualFocus: u } = e.getState();
      u ? I(t) && !K(e, o) && queueMicrotask(U) : I(t) && e.setActiveId(null);
    }), T = i.onBlurCapture, W = F((t) => {
      var o;
      if (T == null || T(t), t.defaultPrevented || !e) return;
      const { virtualFocus: u, activeId: a } = e.getState();
      if (!u) return;
      const p = (o = v(e, a)) == null ? void 0 : o.element, g = t.relatedTarget, C = K(e, g), d = c.current;
      c.current = null, I(t) && C ? (g === p ? d && d !== g && E(d, t) : p ? E(p, t) : d && E(d, t), t.stopPropagation()) : !K(e, t.target) && p && E(p, t);
    }), D = i.onKeyDown, J = ae(m), Q = F((t) => {
      var o;
      if (D == null || D(t), t.nativeEvent.isComposing || t.defaultPrevented || !e || !I(t)) return;
      const { orientation: u, renderedItems: a, activeId: p } = e.getState(), g = v(e, p);
      if ((o = g == null ? void 0 : g.element) != null && o.isConnected) return;
      const C = u !== "horizontal", d = u !== "vertical", y = Ce(a);
      if ((t.key === "ArrowLeft" || t.key === "ArrowRight" || t.key === "Home" || t.key === "End") && z(t.currentTarget)) return;
      const x = {
        ArrowUp: (y || C) && (() => {
          if (y) {
            const P = Ae(a);
            return P == null ? void 0 : P.id;
          }
          return e == null ? void 0 : e.last();
        }),
        ArrowRight: (y || d) && e.first,
        ArrowDown: (y || C) && e.first,
        ArrowLeft: (y || d) && e.last,
        Home: e.first,
        End: e.last,
        PageUp: e.first,
        PageDown: e.last
      }[t.key];
      if (x) {
        const P = x();
        if (P !== void 0) {
          if (!J(t)) return;
          t.preventDefault(), e.move(P);
        }
      }
    });
    i = ce(
      i,
      (t) => /* @__PURE__ */ Fe(re, { value: e, children: t }),
      [e]
    );
    const X = e.useState((t) => {
      var o;
      if (e && n && t.virtualFocus)
        return (o = v(e, t.activeId)) == null ? void 0 : o.id;
    });
    i = fe(B({
      "aria-activedescendant": X
    }, i), {
      ref: le(w, V, i.ref),
      onKeyDownCapture: N,
      onKeyUpCapture: j,
      onFocusCapture: q,
      onFocus: G,
      onBlurCapture: W,
      onKeyDown: Q
    });
    const Y = e.useState(
      (t) => n && (t.virtualFocus || t.activeId === null)
    );
    return i = oe(B({ focusable: Y }, i)), i;
  }
);
ie(function(s) {
  const l = _e(s);
  return se(Se, l);
});
export {
  _e as useComposite
};
//# sourceMappingURL=NSTBQJLB.js.map
